import * as Styled from './styles'
import { Backdrop } from '../Backdrop'
import { TextButton } from '../TextButton'
import { ITwoOptionsBackdrop } from './types'

const TwoOptionsBackdrop = ({
  visible = false,
  title,
  text,
  leftButton,
  rightButton,
  testId = 'two-options',
}: ITwoOptionsBackdrop) => {
  return (
    <Backdrop visible={visible} withBackground={true} testID={testId}>
      <Styled.Container>
        {title && <Styled.TitleSizing align="center">{title}</Styled.TitleSizing>}
        {text && <Styled.Text align="center">{text}</Styled.Text>}

        <Styled.ContainerButton>
          {leftButton && (
            <TextButton testID="left-button" onClick={leftButton.onClick}>
              {leftButton.copy}
            </TextButton>
          )}

          {rightButton && (
            <TextButton testID="right-button" variant="outlined" onClick={rightButton.onClick}>
              {rightButton.copy}
            </TextButton>
          )}
        </Styled.ContainerButton>
      </Styled.Container>
    </Backdrop>
  )
}

export default TwoOptionsBackdrop
